import UserPanel from 'Container/UserPanel';
import Middlewares from '../middlewares/';


const Login = () => import(/* webpackChunkName: "Login" */ 'Views/Auth/Login.vue');

export default {
	path: '/',
	component: UserPanel,
	redirect:'/login',
	children:[
		{
			path: '/login',
			component: Login,
			name: 'login',
			meta: {
				middleware: [Middlewares.guest],
            }
		},
		
	]
}